var _ellipse, _g, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNofilters({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 163,
    height: 113,
    viewBox: "0 0 163 113",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.05,
    cx: 78.076,
    cy: 49.7488,
    rx: 78.076,
    ry: 49.7488,
    transform: "matrix(-0.915086 -0.403258 -0.403298 0.915069 173.02 42.9695)",
    fill: "#72A4FC"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_397_14135)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 22.5,
    width: 139,
    height: 30,
    rx: 4,
    fill: "white",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12.25,
    y: 22.75,
    width: 138.5,
    height: 29.5,
    rx: 3.75,
    stroke: "#F2F2F2",
    strokeWidth: 0.5,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74 35.5C74 34.9477 73.5523 34.5 73 34.5H29C28.4477 34.5 28 34.9477 28 35.5V39.5C28 40.0523 28.4477 40.5 29 40.5H73C73.5523 40.5 74 40.0523 74 39.5V35.5Z",
    fill: "#72A4FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108 35.5C108 34.9477 107.552 34.5 107 34.5H85C84.4477 34.5 84 34.9477 84 35.5V39.5C84 40.0523 84.4477 40.5 85 40.5H107C107.552 40.5 108 40.0523 108 39.5V35.5Z",
    fill: "#E7E7E7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135 35.5C135 34.9477 134.552 34.5 134 34.5H119C118.448 34.5 118 34.9477 118 35.5V39.5C118 40.0523 118.448 40.5 119 40.5H134C134.552 40.5 135 40.0523 135 39.5V35.5Z",
    fill: "#E7E7E7"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_397_14135)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 56.5,
    width: 139,
    height: 30,
    rx: 4,
    fill: "white",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12.25,
    y: 56.75,
    width: 138.5,
    height: 29.5,
    rx: 3.75,
    stroke: "#F2F2F2",
    strokeWidth: 0.5,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74 69.5C74 68.9477 73.5523 68.5 73 68.5H29C28.4477 68.5 28 68.9477 28 69.5V73.5C28 74.0523 28.4477 74.5 29 74.5H73C73.5523 74.5 74 74.0523 74 73.5V69.5Z",
    fill: "#72A4FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108 69.5C108 68.9477 107.552 68.5 107 68.5H85C84.4477 68.5 84 68.9477 84 69.5V73.5C84 74.0523 84.4477 74.5 85 74.5H107C107.552 74.5 108 74.0523 108 73.5V69.5Z",
    fill: "#E7E7E7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135 69.5C135 68.9477 134.552 68.5 134 68.5H119C118.448 68.5 118 68.9477 118 69.5V73.5C118 74.0523 118.448 74.5 119 74.5H134C134.552 74.5 135 74.0523 135 73.5V69.5Z",
    fill: "#E7E7E7"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_397_14135",
    x: 8,
    y: 22.5,
    width: 147,
    height: 38,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.720833 0 0 0 0 0.720833 0 0 0 0 0.720833 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_397_14135"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_397_14135",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_397_14135",
    x: 8,
    y: 56.5,
    width: 147,
    height: 38,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.720833 0 0 0 0 0.720833 0 0 0 0 0.720833 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_397_14135"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_397_14135",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNofilters);
export default __webpack_public_path__ + "static/media/nofilters.76e4573d.svg";
export { ForwardRef as ReactComponent };